import './Error404.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import { getRandomGif } from 'containers/Errors/store/actions';

import A from 'components/A';
import H1 from 'components/H1';
import PageContent from 'components/PageContent';

class Error404 extends React.Component {
    constructor() {
        super();

        this.videoRef = React.createRef();
        this.generateGiphyGif = this.generateGiphyGif.bind(this);
        this.gifTimer = null;
    }

    componentWillMount() {
        document.body.classList.add('error-404-page');
    }

    componentDidMount() {
        this.generateGiphyGif();
    }

    componentWillUnmount() {
        document.body.classList.remove('error-404-page');
        window.clearTimeout(this.gifTimer);
    }

    generateGiphyGif() {
        this.props.getRandomGif()
            .then((res) => {
                if(res.data.data.image_mp4_url != null) {
                    let videoEl = this.videoRef.current;
                    videoEl.src = res.data.image_mp4_url;
                    videoEl.play();
                }
            });

        this.gifTimer = setTimeout(this.generateGiphyGif, 15000);
    }

    render() {
        return (
            <PageContent className="error-404">
                <H1>
                    UH OH, you seem lost!
                </H1>
                <div className="error-404__gif">
                    <video
                        autoPlay
                        loop
                        muted
                        ref={this.videoRef}
                    />
                </div>
                <A to={this.props.auth.user.company !== null ? '/freelancers' : '/opportunities'}>
                    Try searching for what you're looking for!
                </A>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getRandomGif: () => dispatch(getRandomGif())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Error404);



// WEBPACK FOOTER //
// ./src/containers/Errors/Error404/index.js